import { IFormlyConfig } from "AngularFormly";
import { ProgressiveDefinitionSelectTypeController } from "./controller";

export const vsTypeName = "machineConfigurationProgressiveDefinitionSelect";

export const progressiveDefinitionSelectType: AngularFormly.ITypeOptions = {
  name: vsTypeName,
  controller: ProgressiveDefinitionSelectTypeController,
  template: require("!html-loader!./index.html").default,
};

export function progressiveDefinitionSelectTypeConfig(
  formlyConfigProvider: IFormlyConfig
) {
  formlyConfigProvider.setType(progressiveDefinitionSelectType);
}
progressiveDefinitionSelectTypeConfig.$inject = ["formlyConfigProvider"];
